import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    SEARCH_RECEIPT_APPROVAL,
    SEARCH_RECEIPT_APPROVAL_SUCCESS,
    SEARCH_RECEIPT_APPROVAL_FAILED,
    VIEW_RECEIPT_APPROVAL,
    VIEW_RECEIPT_APPROVAL_SUCCESS,
    VIEW_RECEIPT_APPROVAL_FAILED,
    POST_RECEIPT_APPROVAL,
    POST_RECEIPT_APPROVAL_SUCCESS,
    POST_RECEIPT_APPROVAL_FAILED,
    CALCULATE_RECEIPT_POINT,
    CALCULATE_RECEIPT_POINT_SUCCESS,
    CALCULATE_RECEIPT_POINT_FAILED,
    RESET_RECEIPT_APPROVAL_STATUS,
    BACK_TO_LOGIN
} from "constants/ActionTypes";
import {
    searchReceiptApprovalApi,
    viewReceiptApprovalApi,
    postReceiptApprovalApi,
    calculateReceiptApi
} from "../../appRedux/api/ReceiptApproval";

function* fetchSearchReceiptApproval({ payload }) {
    if (!payload) return;
    try {
        const res = yield call(searchReceiptApprovalApi, payload);
        if (res.data.responseCode === "INQ000") {
            yield put({
                type: SEARCH_RECEIPT_APPROVAL_SUCCESS,
                payload: res.data
            });
        } else {
            yield put({
                type: SEARCH_RECEIPT_APPROVAL_FAILED,
                payload: res.data.responseMessage || "Inquiry failed"
            });
        }
    } catch (error) {
        const data = error && error.response && error.response.data;
        if (data && data.abstractResponse && data.abstractResponse.responseStatus === "AUTH001") {
            yield put({ type: BACK_TO_LOGIN, payload: data.abstractResponse.responseMessage });
            return;
        }
        yield put({
            type: SEARCH_RECEIPT_APPROVAL_FAILED,
            payload: (data && data.responseMessage) || "Sorry, this feature is not accessible at this time."
        });
    }
}

function* fetchViewReceiptApproval({ payload }) {
    if (!payload) return;
    try {
        const res = yield call(viewReceiptApprovalApi, payload);
        if (res.data.responseCode === "INQ000") {
            yield put({
                type: VIEW_RECEIPT_APPROVAL_SUCCESS,
                payload: res.data.body
            });
        } else {
            yield put({
                type: VIEW_RECEIPT_APPROVAL_FAILED,
                payload: res.data.responseMessage || "Inquiry failed"
            });
        }
    } catch (error) {
        const data = error && error.response && error.response.data;
        if (data && data.abstractResponse && data.abstractResponse.responseStatus === "AUTH001") {
            yield put({ type: BACK_TO_LOGIN, payload: data.abstractResponse.responseMessage });
            return;
        }
        yield put({
            type: VIEW_RECEIPT_APPROVAL_FAILED,
            payload: (data && data.responseMessage) || "Sorry, this feature is not accessible at this time."
        });
    }
}

function* postReceiptApproval({ payload }) {
    if (!payload) return;
    try {
        const res = yield call(postReceiptApprovalApi, payload);
        if (res.data.responseCode === "INQ000" || res.data.responseCode === "INQ004") {
            yield put({ type: POST_RECEIPT_APPROVAL_SUCCESS, payload: res.data });
        } else {
            yield put({
                type: POST_RECEIPT_APPROVAL_FAILED,
                payload: { alertMessage: res.data.responseMessage || "Update failed", data: res.data }
            });
        }
    } catch (error) {
        const data = error && error.response && error.response.data;
        if (data && data.abstractResponse && data.abstractResponse.responseStatus === "AUTH001") {
            yield put({ type: BACK_TO_LOGIN, payload: data.abstractResponse.responseMessage });
            return;
        }
        yield put({
            type: POST_RECEIPT_APPROVAL_FAILED,
            payload: {
                alertMessage: (data && data.responseMessage) || "Sorry, this feature is not accessible at this time.",
                data
            }
        });
    }
}

export function* watchSearchReceiptApproval() {
    yield takeEvery(SEARCH_RECEIPT_APPROVAL, fetchSearchReceiptApproval);
}
export function* watchViewReceiptApproval() {
    yield takeEvery(VIEW_RECEIPT_APPROVAL, fetchViewReceiptApproval);
}
export function* watchPostReceiptApproval() {
    yield takeEvery(POST_RECEIPT_APPROVAL, postReceiptApproval);
}

function* fetchCalculate({ payload }) {
    if (!payload) return;
    try {
        yield put({ type: RESET_RECEIPT_APPROVAL_STATUS });
        const res = yield call(calculateReceiptApi, payload);
        if (res.data.responseCode === "INQ000" || res.data.responseCode === "INQ004") {
            const body = res.data.body || {};
            yield put({
                type: CALCULATE_RECEIPT_POINT_SUCCESS,
                payload: { accPoint: body.accPoint != null ? body.accPoint : (body.point != null ? body.point : 0) }
            });
        } else {
            yield put({
                type: CALCULATE_RECEIPT_POINT_FAILED,
                payload: res.data.responseMessage || "Calculate failed"
            });
        }
    } catch (error) {
        const data = error && error.response && error.response.data;
        if (data && data.abstractResponse && data.abstractResponse.responseStatus === "AUTH001") {
            yield put({ type: BACK_TO_LOGIN, payload: data.abstractResponse.responseMessage });
            return;
        }
        yield put({
            type: CALCULATE_RECEIPT_POINT_FAILED,
            payload: (data && data.responseMessage) || "Calculate service unavailable"
        });
    }
}

export function* watchCalculateReceipt() {
    yield takeEvery(CALCULATE_RECEIPT_POINT, fetchCalculate);
}

export default function* rootReceiptApprovalSaga() {
    yield all([
        fork(watchSearchReceiptApproval),
        fork(watchViewReceiptApproval),
        fork(watchPostReceiptApproval),
        fork(watchCalculateReceipt)
    ]);
}
